/*
 * @Author: Tina Huang
 * @Date: 2024-02-19 10:09:21
 * @LastEditors: Tina Huang
 * @LastEditTime: 2024-07-15 13:02:27
 * @Description:
 */
import { logs } from '@/constants/logs'
import { Alert, Timeline } from 'antd'

export default function Logs() {
  const logItem = (item: any) => {
    return (
      <Alert message={<p dangerouslySetInnerHTML={{ __html: item.content }}></p>} description={`版本：${item.version}`} type={item.type} />
    )
  }
  const items = logs.map((item) => {
    return {
      children: logItem(item),
      color: item.type === 'success' ? 'green' : 'blue',
      label: item.date,
    }
  })

  return (
    <>
      <Timeline mode="alternate" items={items} />
    </>
  )
}
